//import axios from 'axios'

const state = {
  annoaccademico: null,
  semestre: null,
  dati: {
    unita_accademica_scelta: {
      CODICENU: null,
      DECODIF: null,
    },
    fac_scelta: {
      CODICENU: null,
      DECODIF: null
  },
  ciclo_scelto: {
      CODICENU: null,
      DECODIF: null
  },
  spec_scelta: {
      CODICENU: null,
      DECODIFICA: null
  },
  anno_scelto: null,
  tipoIscrizione_scelta: null,
  categoria_scelta: {
      CODICENU: null,
      DECODIF: null
  },
  flagOspite: null
  }
};
const getters = {};
const actions = {
  async salvaDati({ commit }, payload) {
    await commit(payload.azione, payload.dati);
  },
};
const mutations = {
  setIscrizione: (state, dati) => {
    alert(JSON.stringify(dati));
    //state.riepilogo.iscrizione.facolta.val = dati.fac_scelta.CODICENU
    //state.riepilogo.iscrizione.facolta.desc = dati.fac_scelta.DECODIF
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
